import './SankeyChart.css';
export var graphAreaCell = '_s3m3d2-3-12-1';
export var graphAreaContainer = '_s3m3d1-3-12-1';
export var graphAreaWrapper = '_s3m3d0-3-12-1';